import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'relativeDate', pure: true})
export class RelativeDatePipe implements PipeTransform {
  transform(dateStr: string): string {
    const date = moment(dateStr, 'YYYY-MM-DDTHH:mm:ssZ', true);
    const duration = moment.duration(moment().utc().diff(date));
    const hours = duration.asHours();
    if (hours < 1) {
      return Math.round(duration.asMinutes()) + ' m';
    }
    if (hours < 24) {
      return Math.round(hours) + ' h';
    }
    const weeks = duration.asWeeks();
    if (weeks < 1) {
      return Math.round(duration.asDays()) + ' d';
    }
    const years = duration.asYears();
    if (years < 1) {
      return Math.round(weeks) + ' w';
    }
    return Math.round(years) + ' y';
  }
}
